module.exports = __webpack_public_path__ + "img/icon47.cda3c7b4.png";